import { connect } from "react-redux";
import { startNewGame, togglePreview } from "actions";
import PuzzleComponent from "../components/PuzzleComponent";

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => ({
  startNewGame: () => {
    dispatch(startNewGame());
  },
  togglePreview: () => {
    dispatch(togglePreview());
  }
});

const PuzzleContainer = connect(mapStateToProps, mapDispatchToProps)(
  PuzzleComponent
);

export default PuzzleContainer;



// WEBPACK FOOTER //
// ./src/routes/puzzles/containers/PuzzleContainer.js